<template>
    <div class="group-pending-dues-table">
        <!-- Main content -->
        <section name="peding-dues">
        <!-- Default box -->
        <div class="card card-outline mt-3 card-info">
            <div class="card-body">
                <table id="example1" class="table table-striped">
                <thead class="table-custom-header">
                <tr>
                    <th width="400">Based on Loan Terms:</th>
                    <th style="text-align:right" width="200">Principal</th>
                    <th style="text-align:right" width="200">Interest</th>
                    <th style="text-align:right" width="200">Penalty</th>
                    <th style="text-align:right" width="200">Total</th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><button class="btn btn-danger btn-sm w-50">Total Due </button></td>
                        <td style="text-align:right">{{currency(term.principal)}}</td>
                        <td style="text-align:right">{{currency(term.interest)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(term.total_due)}}</td>
                    </tr>
                    <tr>
                        <td><button class="btn btn-success btn-sm w-50">Total Paid </button></td>
                        <td style="text-align:right">{{currency(term.principal_paid)}}</td>
                        <td style="text-align:right">{{currency(term.interest_paid)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(term.total_paid)}}</td>
                    </tr>
                     <tr>
                        <td><button class="btn btn-dark btn-sm w-50">Balance </button></td>
                        <td style="text-align:right">{{currency(term.principal_balance)}}</td>
                        <td style="text-align:right">{{currency(term.interest_balance)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(term.total_balance)}}</td>
                    </tr>
                </tbody>
                </table>
                <table id="example1" class="table table-striped">
                <thead class="table-custom-header">
                <tr>
                    <th width="400">Based on Loan Schedule:</th>
                    <th width="200"></th>
                    <th width="200"></th>
                    <th width="200"></th>
                    <th width="200"></th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><button class="btn btn-danger btn-sm w-50">Due till {{ formatDate(schedule.due_till) }}  </button></td>
                        <td style="text-align:right">{{currency(schedule.sum_principal)}}</td>
                        <td style="text-align:right">{{currency(schedule.sum_interest)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(schedule.total_due_till)}}</td>
                    </tr>
                    <tr>
                        <td><button class="btn btn-success btn-sm w-50">Paid till {{ formatDate(schedule.paid_till) }}  </button></td>
                        <td style="text-align:right">{{currency(schedule.sum_principal_paid)}}</td>
                        <td style="text-align:right">{{currency(schedule.sum_interest_paid)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(schedule.total_paid_till)}}</td>
                    </tr>
                     <tr>
                        <td><button class="btn btn-dark btn-sm w-50">Balance {{ formatDate(schedule.balance_till) }} </button></td>
                        <td style="text-align:right">{{currency(schedule.sum_balance_principal)}}</td>
                        <td style="text-align:right">{{currency(schedule.sum_balance_interest)}}</td>
                        <td style="text-align:right">0</td>
                        <td style="text-align:right">{{currency(schedule.total_balance_till)}}</td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
        <!-- /.card -->
        </section>
        <!-- /.content -->
    
    </div>
    </template>
    
    <script>
    export default {
       data() {
            return {
                term:{},
                schedule:{}
            }
        },
    
        created(){
            this.fetchUserPendingDuesTerms(this.$route.params.id);
            this.fetchUserPendingDuesSchedule(this.$route.params.id);
        },
        methods: {
            async fetchUserPendingDuesTerms(param) {
                 let response = await  axios.get('api/pendingDues/term/' + param)
                 this.term = response.data
                // console.log('response => test:', JSON.stringify(this.term))
            },

             async fetchUserPendingDuesSchedule(param) {
                 let response = await  axios.get('api/pendingDues/schedule/' + param)
                 this.schedule = response.data
                 console.log('response => schedule:', JSON.stringify(this.schedule))
            },

             formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

        },
    }
    </script>